/* eslint-disable */

const IconBack = ({className = ""}) => (
    <svg className={className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 11H6.83l2.88-2.88A.996.996 0 108.3 6.71L3.71 11.3a.996.996 0 000 1.41L8.3 17.3a.996.996 0 101.41-1.41L6.83 13H20c.55 0 1-.45 1-1s-.45-1-1-1z" fill="#008C8C"/></svg>
);

export default IconBack;